import $ from 'jquery';
import StringColumn from './StringColumn';
import Globalize from 'globalize';
import {noValue} from './StringColumn';
const log = require('debug')('linksoft:datatables:NumericColumn');

export default class NumericColumn extends StringColumn {

	get isFloat() {
		return this.options.type === 'float';
	}

	getNumber(value) {
		if(typeof value === 'string') {
			value = this.isFloat ? parseFloat(value) : parseInt(value, 10);
		}
		return isNaN(value) ? null : value;
	}

	displayValue(value) {
		const number = this.getNumber(value);
		return typeof number === 'number' && !isNaN(number) ? this._getFormattedValue(value) : noValue;
	}

	_getFormattedValue(value) {
		const formatted = Globalize.format(value, this.options.formatString);
		return typeof formatted === 'string' ? formatted.replace(' ', '&nbsp;') : formatted;
	}

	createEditor(value) {
		if (typeof value === 'number') {
			value = '' + value;
		}
		return $(`<input class="table-input" type="number" step="${this.isFloat ? 0.01 : 1}"/>`).val(value || '').get(0);
	}

	getEditorValue(cellElement) {
		let inputValue = super.getEditorValue(cellElement);

		if (this.isFloat) {
			// TODO: make comma and dot decimal separator based on which is the last, remove all others non-digits
		}

		if(!inputValue) return null;
		try {
			return this.getNumber(inputValue);
		} catch (error) {
			log('An error occured while getting value from table cell editor. %o', error);
		}
		return inputValue;
	}

	// -------------- FILTERS --------------------

	createFilter() {
		return (
`<div class="input-group">
	<input type="number" class="form-control input-sm table-filter" step="${this.isFloat ? 0.01 : 1}">
	<span class="input-group-addon">-</span>
	<input type="number" class="form-control input-sm table-filter" step="${this.isFloat ? 0.01 : 1}">
</div>'`
		);
	}

	buildFilterExpression(fieldName, columnFilter) {
		// Currently, we cannot use global search for date and numeric fields (exception on the OData service side)
		// However, individual column filters are supported in form lower~upper
		if (columnFilter.indexOf("~") > -1) {
			const ranges = columnFilter.split("~");
			const rangeQuery = [];
			if (ranges[0]) {
				rangeQuery.push("(" + fieldName + " ge " + ranges[0] + ")");
			}
			if (ranges[1]) {
				rangeQuery.push("(" + fieldName + " le " + ranges[1] + ")");
			}
			return "(" + rangeQuery.join(" and ") + ")";
		} else {
			return "(" + fieldName + " eq " + columnFilter + ")";
		}
	}

	exportRender(value, row, meta) {
		return value;
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/NumericColumn.js